import api from "@/lib/api";

export async function assumirSolicitacao(id) {
  const { data } = await api.post("/secretaria-digital/solicitacao/assumir", { id })
  return data
}